import { render, staticRenderFns } from "./NewBadge.vue?vue&type=template&id=2b0a6aea&scoped=true"
import script from "./NewBadge.vue?vue&type=script&lang=js"
export * from "./NewBadge.vue?vue&type=script&lang=js"
import style0 from "./NewBadge.vue?vue&type=style&index=0&id=2b0a6aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a6aea",
  null
  
)

export default component.exports